var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Card as MuiCard } from '@mui/material';
var Card = function (_a) {
    var children = _a.children, _b = _a.fullWidth, fullWidth = _b === void 0 ? false : _b, _c = _a.padding, padding = _c === void 0 ? '32px' : _c;
    var styles = {
        maxWidth: fullWidth ? '100%' : 'auto',
        position: 'relative',
        padding: padding
    };
    return _jsx(MuiCard, __assign({ sx: styles }, { children: children }));
};
export default Card;
